import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V_All = {
  '@id': string;
  '@type': 'OrganisationTeam';
  id: string;
  name: string;
  organisation: {
    '@id': string;
    '@type': 'Organisation';
    name: string;
  };
};

export type V_OrganisationSub = {
  '@id': string;
  '@type': 'OrganisationTeam';
  id: string;
  name: string;
  programStartDate: string;
  coach: {
    '@id': string;
    '@type': 'User';
    id: string;
    name: string | null;
  };
  licenceCount: number;
  claimedLicenceCount: number;
};

export type V_UserSub = {
  '@id': string;
  '@type': 'OrganisationTeam';
  name: string;
  programStartDate: string;
  programProgress: {
    '@id': string;
    '@type': 'ProgramProgress';
    status: string;
    startDate: string | null;
    currentWeekNumber: number | null;
    endDate: string | null;
  } | null;
  organisation: {
    '@id': string;
    '@type': 'Organisation';
    name: string;
  };
  claimedLicenceCount: number;
  activeMemberCount: number;
};

export type W = {
  programStartDate: string;
  coach: string;
  organisation: string;
};

export type W_AddLicence = {
  noOfLicences: number | null;
  licenceExpiresAt: string | null;
};

export type W_Update = {
  programStartDate: string;
  coach: string;
};

export function useReadCollection(
  queryParams?: { 'order[programStartDate]'?: string; search?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_All>>(
    `/organisation-teams${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadCollectionOrganisationSub(
  id: string,
  queryParams?: { 'order[programStartDate]'?: string; search?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_OrganisationSub>>(
    `/organisations/${id}/teams${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadCollectionUserSub(
  id: string,
  queryParams?: { 'order[programStartDate]'?: string; search?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_UserSub>>(
    `/users/${id}/teams${makeQueryString(queryParams)}`,
    options,
  );
}
